// extracted by mini-css-extract-plugin
export var voiceConversionContent = "_mb-0";